import React from "react";
import { Flex, Text } from "@chakra-ui/react";
import AppCheckBox from "@/features/line-sheet-sets/app-checkbox";

interface Props {
  label: string;
  // 라벨 뒤에 붙는 짧은 안내(예: 비활성 사유)
  suffix?: string;
  isSelected: boolean;
  isDisabled?: boolean;
  onToggle: () => void;
}

// 신청 모달의 선택 카드 — 파일 신청의 양식 선택과 API 연동의 채널 선택이 함께 쓴다.
// 카드 전체를 클릭 대상으로 하고, AppCheckBox에는 onChange를 넘기지 않아
// 체크박스 클릭이 카드 onClick으로 버블되어 한 번만 토글되게 한다.
// 비활성일 때는 카드에만 회색을 얹으면 된다 — AppCheckBox의 라벨 Text는 color를 지정하지 않아 상속된다.
const PathPickBasketCheckCard = ({
  label,
  suffix,
  isSelected,
  isDisabled = false,
  onToggle,
}: Props) => (
  <Flex
    flex={1}
    alignItems={"center"}
    gap={"6px"}
    padding={"8px 12px"}
    cursor={isDisabled ? "default" : "pointer"}
    border={isSelected ? "1px solid #1272EF" : "0.5px solid #D4D4D1"}
    borderRadius={"8px"}
    background={isDisabled ? "#F7F9FA" : "#FFFFFF"}
    color={isDisabled ? "#8F8F8C" : undefined}
    onClick={isDisabled ? undefined : onToggle}
    _hover={isDisabled ? undefined : { borderColor: "#1272EF" }}
  >
    <AppCheckBox
      size={"small"}
      isChecked={isSelected}
      isDisabled={isDisabled}
      name={label}
    />
    {suffix && (
      <Text textStyle={"caption-medium"} color={"#8F8F8C"}>
        {suffix}
      </Text>
    )}
  </Flex>
);

export default PathPickBasketCheckCard;
